import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface FormFieldProps {
    id: string
    label: string
    hint?: string
    error?: string | null
    optional?: boolean
    className?: string
    children: ReactNode
}

export const FormField: FC<FormFieldProps> = ({
    id,
    label,
    hint,
    error,
    optional,
    className,
    children
}): ReactNode => {
    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <Label htmlFor={id}>
                {label}

                {optional && (
                    <span className='text-xs font-medium text-muted-foreground'>
                        Optional
                    </span>
                )}
            </Label>

            {children}

            {error
                ? (
                    <p id={`${id}-error`} role='alert' className='text-sm font-medium text-destructive'>
                        {error}
                    </p>
                )
                : hint && (
                    <p id={`${id}-hint`} className='text-sm text-muted-foreground'>
                        {hint}
                    </p>
                )}
        </div>
    )
}
